import { mapDataSource, RawDataSource } from '~/Api/DataSource';
import Price from '~/libs/Price';

import ReferencedProduct from './ReferencedProduct';

export interface RawReferencedProduct {
	id: string;
	currentExFactoryPrice: Price;
	dataSource: RawDataSource;
}

export default function mapReferencedProduct(product: RawReferencedProduct): ReferencedProduct {
	return new ReferencedProduct(
		product.id,
		new Price(product.currentExFactoryPrice.value, product.currentExFactoryPrice.currency),
		mapDataSource(product.dataSource)
	);
}
